import desktopMenu from "./desktop-menu.js";
import mobileMenu from "./mobile-menu.js";

const collageGroup = {
  debounce: function (func, timeout = 300) {
    let timer;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  },

  init: function () {
    const desktopQuery = window.matchMedia("(min-width: 1120px)");

    if (desktopQuery.matches) {
      // Desktop functions
      desktopMenu.init();
      mobileMenu.kill();
    } else {
      // Mobile functions
      mobileMenu.init();
      desktopMenu.kill();
    }

    this.scrollTransitions();

    document.addEventListener("keyup", this.preventSpaceBarFocus);
  },

  scrollTransitions: function () {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach((entry) => {
            if (entry.target.classList.contains("scroll-transitions-active")) {
              return;
            }

            if (entry.isIntersecting) {
              entry.target.classList.add("scroll-transitions-active");
            }
          });
        },
        { rootMargin: "-100px 0px -100px 0px" }
      );

      const scrollItems = document.querySelectorAll(".scroll-transitions");

      scrollItems.forEach((scrollItem) => {
        observer.observe(scrollItem);
      });

      const staggerItems = document.querySelectorAll(
        ".scroll-transitions-stagger"
      );

      if (staggerItems) {
        let index = 0;
        let currentParent = staggerItems[0].parentNode;

        staggerItems.forEach((staggerItem) => {
          if (staggerItem.parentNode !== currentParent) {
            index = 0;
            currentParent = staggerItem.parentNode;
          }

          staggerItem.style.setProperty("--i", index);
          index++;
        });
      }
    }
  },

  preventSpaceBarFocus: function (e) {
    if (e.which === 32) {
      e.preventDefault();
    }
  },
};

// const debouncedInit = collageGroup.debounce(
//   collageGroup.init.bind(collageGroup)
// );

document.addEventListener(
  "DOMContentLoaded",
  collageGroup.init.bind(collageGroup)
);
// window.addEventListener("resize", debouncedInit);
